import dispatcher from '../dispatcher/dispatcher.js';

export function getTree(){
    dispatcher.dispatch({
        type: 'GET_TREE'
    });
}
export function addTree(treeObj){
    dispatcher.dispatch({
        type: "ADD_TREE",
        object: treeObj
    });
}
export function editTree(treeObj){
    dispatcher.dispatch({
        type: "EDIT_TREE",
        object:treeObj
    })
}
export function deleteTree(treeObj){
    dispatcher.dispatch({
        type: "DELETE_TREE",
        object:treeObj
    })
}
export function setTree(treeObj){
    dispatcher.dispatch({
        type: "SET_TREE",
        object:treeObj
    })
}
export function setTreeName(treeName){
    dispatcher.dispatch({
        type: "SET_TREE_NAME",
        object: treeName
    })
}


// WEBPACK FOOTER //
// ./src/action/treeAction.js